(function installMoroccanSimulatorHandoff(global) {
  "use strict";

  const VERSION = "1";
  const INIT_TIMEOUT_MS = 15000;
  const POLL_INTERVAL_MS = 200;
  const SUPPORTED_HANDLES = new Set(["mo", "mmo", "moroh"]);
  const ALLOWED_COLORS = new Set(["natural", "brown", "black", "white"]);
  const ALLOWED_TILE_TYPES = new Set(["normal", "art"]);
  const ALLOWED_PLATE_FLAGS = new Set(["0", "1"]);
  const ALLOWED_SQUARE_TYPES = new Set(["A", "B", "C", "D", "E", "F"]);
  const ALLOWED_PLATE_POSITIONS = new Set(["center", "br"]);
  const ALLOWED_PLATES = new Set(["P4", "P7", "P10", "P12", "P13", "P16", "P17", "P22", "P24", "P27"]);
  const DESIGN_ID_PATTERN = /^d_[0-9A-Za-z]{22}$/;
  const PROPERTY_ATTRIBUTE = "data-moss-sim-property";
  const PROPERTY_DEFINITIONS = Object.freeze({
    source: Object.freeze({ name: "properties[シミュレーター経由]", value: "あり" }),
    platePosition: Object.freeze({ name: "properties[シミュレーター：プレート位置]" }),
    plateType: Object.freeze({ name: "properties[シミュレーター：プレート種類]" }),
    designId: Object.freeze({ name: "properties[シミュレーターDesign ID]" }),
  });
  const PLATE_POSITION_VALUES = Object.freeze({ center: "中央", br: "右下" });

  const FIELD_CONFIG = Object.freeze({
    mo: Object.freeze({
      print: "print",
      size: Object.freeze({ printed: "size", unprinted: "size0" }),
      color: "color",
      tileType: "タイルの種類",
    }),
    mmo: Object.freeze({
      print: "print",
      size: Object.freeze({ printed: "size", unprinted: "size[無記名]" }),
      color: "select-12",
      tileType: "select-14",
    }),
    moroh: Object.freeze({
      print: "print",
      size: Object.freeze({ printed: "size", unprinted: "size0" }),
      color: "color",
      tileType: "タイルの種類",
      plate: "プレートの取付",
    }),
  });

  const COLOR_VALUES = Object.freeze({
    natural: "フレームカラー【ナチュラル】",
    brown: "フレームカラー【ブラウン】",
    black: "フレームカラー【ブラック】",
    white: "フレームカラー【ホワイト】",
  });
  const TILE_TYPE_VALUES = Object.freeze({ normal: "ノーマルタイル", art: "ARTプレート(一式価格)" });
  const PLATE_VALUES = Object.freeze({ "0": "なし", "1": "取付あり" });
  const MO_SIZE_RANGES = Object.freeze({
    "20": "1-7枚", "25": "8-12枚", "30": "13-24枚", "35": "25-40枚",
    "45": "41-60枚", "50": "61-84枚", "60": "85-112枚",
  });
  const MMO_SIZE_TYPES = Object.freeze({ "25": "Type A", "30": "Type B", "35": "Type C", "45": "Type D", "50": "Type E", "60": "Type F" });
  const MOROH_SIZE_LABELS = Object.freeze({
    "15x30": "15×30cm 5個まで",
    "25x50": "25×50cm 32個まで",
    "30x60": "30×60cm 52個まで",
    "35x70": "35×70cm 85個まで",
    "30x90": "30×90cm 87個まで",
    "40x80": "40×80cm 103個まで",
    "50.5x66": "50.5×66cm 104個まで",
    "77x58": "★58×77cm 147個まで",
  });

  function normalizeOptionText(value) {
    return String(value || "")
      .normalize("NFKC")
      .replace(/[\s\u3000]+/g, "")
      .replace(/\[印刷なし\]/g, "")
      .toLowerCase();
  }

  function parseHandoffParams(input) {
    const params = input instanceof URLSearchParams ? input : new URL(String(input), "https://example.invalid").searchParams;
    if (params.get("sim_v") !== VERSION) return null;
    const result = { sim_v: VERSION };
    const size = params.get("sim_size");
    if (size) result.sim_size = size;
    const color = params.get("sim_color");
    if (ALLOWED_COLORS.has(color)) result.sim_color = color;
    const tile = params.get("sim_tile");
    if (ALLOWED_TILE_TYPES.has(tile)) result.sim_tile = tile;
    const plate = params.get("sim_plate");
    if (ALLOWED_PLATE_FLAGS.has(plate)) result.sim_plate = plate;
    const type = params.get("sim_type");
    if (ALLOWED_SQUARE_TYPES.has(type)) result.sim_type = type;
    const position = params.get("sim_pp");
    if (ALLOWED_PLATE_POSITIONS.has(position)) result.sim_pp = position;
    const plateId = params.get("sim_p");
    if (ALLOWED_PLATES.has(plateId)) result.sim_p = plateId;
    const designId = params.get("sim_design");
    if (DESIGN_ID_PATTERN.test(designId || "")) result.sim_design = designId;
    return result;
  }

  function getSemanticSizeLabel(handle, size) {
    if (handle === "mo") return MO_SIZE_RANGES[size] || null;
    if (handle === "mmo") return MMO_SIZE_TYPES[size] || null;
    if (handle === "moroh") return MOROH_SIZE_LABELS[size] || null;
    return null;
  }

  function findSemanticOption(select, semanticValue) {
    if (!select || !semanticValue) return null;
    const needle = normalizeOptionText(semanticValue);
    return Array.from(select.options || []).find((option) => {
      const value = normalizeOptionText(option.value);
      const label = normalizeOptionText(option.textContent || option.label);
      return value === needle || label === needle || value.includes(needle) || label.includes(needle);
    }) || null;
  }

  function isVisibleSelect(select) {
    if (!select || String(select.tagName).toUpperCase() !== "SELECT" || select.disabled || select.hidden) return false;
    if (typeof select.getClientRects === "function" && select.getClientRects().length === 0) return false;
    return true;
  }

  function setVisibleSelect(select, desiredValue, semantic) {
    if (!isVisibleSelect(select)) return false;
    const option = semantic ? findSemanticOption(select, desiredValue) : Array.from(select.options || []).find((item) => item.value === desiredValue);
    if (!option || select.value === option.value) return false;
    select.value = option.value;
    select.dispatchEvent(new Event("input", { bubbles: true }));
    select.dispatchEvent(new Event("change", { bubbles: true }));
    return true;
  }

  function escapeAttributeValue(value) {
    return String(value).replace(/\\/g, "\\\\").replace(/"/g, '\\"');
  }

  function findSelect(app, fieldName) {
    return app.querySelector(`select[data-field-name="${escapeAttributeValue(fieldName)}"]`);
  }

  function detectProductContext(doc) {
    const candidates = Array.from(doc.querySelectorAll(".product-section[data-product-handle], form[data-product-handle]"));
    for (const root of candidates) {
      const handle = root.getAttribute("data-product-handle");
      if (!SUPPORTED_HANDLES.has(handle)) continue;
      const app = root.matches(".gpo-app") ? root : root.querySelector(".gpo-app");
      if (app) return { handle, root, app };
    }
    return null;
  }

  function findTargetProductForm(context) {
    if (!context || !SUPPORTED_HANDLES.has(context.handle)) return null;
    const selector = `form[data-product-handle="${escapeAttributeValue(context.handle)}"]`;
    const closest = typeof context.app.closest === "function" ? context.app.closest(selector) : null;
    if (closest) return closest;
    if (context.root.matches(selector)) return context.root;
    return context.root.querySelector(selector);
  }

  function buildLineItemProperties(handle, handoff) {
    if (!SUPPORTED_HANDLES.has(handle) || !handoff || handoff.sim_v !== VERSION) return [];
    const properties = [{ key: "source", ...PROPERTY_DEFINITIONS.source }];
    if (handoff.sim_design && DESIGN_ID_PATTERN.test(handoff.sim_design)) {
      properties.push({ key: "design-id", name: PROPERTY_DEFINITIONS.designId.name, value: handoff.sim_design });
    }
    const hasPlate = handle === "mmo" || (handle === "moroh" && handoff.sim_plate === "1");
    if (hasPlate && handoff.sim_pp && handoff.sim_p && ALLOWED_PLATE_POSITIONS.has(handoff.sim_pp) && ALLOWED_PLATES.has(handoff.sim_p)) {
      properties.push({ key: "plate-position", name: PROPERTY_DEFINITIONS.platePosition.name, value: PLATE_POSITION_VALUES[handoff.sim_pp] });
      properties.push({ key: "plate-type", name: PROPERTY_DEFINITIONS.plateType.name, value: handoff.sim_p });
    }
    return properties;
  }

  function syncLineItemProperties(context, handoff) {
    const form = findTargetProductForm(context);
    if (!form) return false;
    const desired = new Map(buildLineItemProperties(context.handle, handoff).map((property) => [property.key, property]));
    const managed = Array.from(form.querySelectorAll(`[${PROPERTY_ATTRIBUTE}]`));
    const existingByKey = new Map();
    for (const input of managed) {
      const key = input.getAttribute(PROPERTY_ATTRIBUTE);
      if (!desired.has(key) || existingByKey.has(key)) input.remove();
      else existingByKey.set(key, input);
    }
    for (const [key, property] of desired) {
      let input = existingByKey.get(key);
      if (!input) input = Array.from(form.querySelectorAll("input[type=\"hidden\"]")).find((candidate) => candidate.name === property.name);
      if (!input) {
        input = form.ownerDocument.createElement("input");
        input.type = "hidden";
        form.appendChild(input);
      }
      input.setAttribute(PROPERTY_ATTRIBUTE, key);
      if (input.name !== property.name) input.name = property.name;
      if (input.value !== property.value) input.value = property.value;
      if (input.getAttribute("value") !== property.value) input.setAttribute("value", property.value);
    }
    return true;
  }

  function getPrintBranch(printSelect) {
    if (!printSelect || !printSelect.value) return null;
    const value = normalizeOptionText(printSelect.value);
    if (value.includes("印刷なし")) return "unprinted";
    if (value.includes("印刷有り") || value.includes("印刷あり")) return "printed";
    return null;
  }

  function syncNonPrintFields(context, handoff) {
    const config = FIELD_CONFIG[context.handle];
    if (handoff.sim_color) setVisibleSelect(findSelect(context.app, config.color), COLOR_VALUES[handoff.sim_color], false);
    if (handoff.sim_tile) setVisibleSelect(findSelect(context.app, config.tileType), TILE_TYPE_VALUES[handoff.sim_tile], false);
    if (context.handle === "moroh" && handoff.sim_plate) setVisibleSelect(findSelect(context.app, config.plate), PLATE_VALUES[handoff.sim_plate], false);
  }

  function syncPrintDependentSize(context, handoff) {
    if (!handoff.sim_size) return false;
    const config = FIELD_CONFIG[context.handle];
    const printSelect = findSelect(context.app, config.print);
    const branch = getPrintBranch(printSelect);
    if (!branch) return false;
    const sizeSelect = findSelect(context.app, config.size[branch]);
    const semanticLabel = getSemanticSizeLabel(context.handle, handoff.sim_size);
    return setVisibleSelect(sizeSelect, semanticLabel, true);
  }

  function attachPrintSync(context, handoff) {
    const printSelect = findSelect(context.app, FIELD_CONFIG[context.handle].print);
    if (!printSelect || printSelect.dataset.moroccanHandoffBound === VERSION) return;
    printSelect.dataset.moroccanHandoffBound = VERSION;
    printSelect.addEventListener("change", () => syncPrintDependentSize(context, handoff));
  }

  function initialize(doc, locationLike) {
    const handoff = parseHandoffParams(locationLike.href);
    const startedAt = Date.now();
    let timer = null;
    let observer = null;
    let stopObserverTimer = null;
    const stop = () => {
      if (timer !== null) global.clearInterval(timer);
      if (observer) observer.disconnect();
      if (stopObserverTimer !== null) global.clearTimeout(stopObserverTimer);
      timer = null;
      observer = null;
      stopObserverTimer = null;
    };
    const attempt = () => {
      const context = detectProductContext(doc);
      if (!context) {
        if (Date.now() - startedAt >= INIT_TIMEOUT_MS) stop();
        return false;
      }
      const sync = () => {
        syncLineItemProperties(context, handoff);
        if (handoff) {
          syncNonPrintFields(context, handoff);
          syncPrintDependentSize(context, handoff);
          attachPrintSync(context, handoff);
        }
      };
      sync();
      if (timer !== null) global.clearInterval(timer);
      timer = null;
      // Globo may create or replace the active size branch after the print change.
      // Observe only this product's app and disconnect after the bounded mount window.
      if (typeof global.MutationObserver === "function" && context.app.dataset.moroccanHandoffObserved !== VERSION) {
        context.app.dataset.moroccanHandoffObserved = VERSION;
        observer = new global.MutationObserver(sync);
        observer.observe(context.app, { childList: true, subtree: true });
        stopObserverTimer = global.setTimeout(() => {
          if (observer) observer.disconnect();
          observer = null;
          stopObserverTimer = null;
          delete context.app.dataset.moroccanHandoffObserved;
        }, Math.max(0, INIT_TIMEOUT_MS - (Date.now() - startedAt)));
      }
      return true;
    };
    if (!attempt()) timer = global.setInterval(attempt, POLL_INTERVAL_MS);
    return { status: handoff ? "started" : "ignored", stop };
  }

  const api = Object.freeze({
    FIELD_CONFIG,
    normalizeOptionText,
    parseHandoffParams,
    getSemanticSizeLabel,
    findSemanticOption,
    isVisibleSelect,
    setVisibleSelect,
    getPrintBranch,
    detectProductContext,
    findTargetProductForm,
    buildLineItemProperties,
    syncLineItemProperties,
    initialize,
  });
  global.MoroccanSimulatorHandoff = api;

  if (global.document && global.location) {
    const boot = () => initialize(global.document, global.location);
    if (global.document.readyState === "loading") global.document.addEventListener("DOMContentLoaded", boot, { once: true });
    else boot();
    global.addEventListener("pageshow", boot);
  }
})(globalThis);
